import React, { useEffect, useMemo, useState } from 'react';
const DAY_IN_SECONDS = 24 * 60 * 60;
function format(value: number) {
  return String(value).padStart(2, '0');
}
type CountdownProps = {
  label: string;
  note?: string;
};
export function Countdown({
  label,
  note
}: CountdownProps) {
  const [remaining, setRemaining] = useState(DAY_IN_SECONDS - 12);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? DAY_IN_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const units = useMemo(() => [{
    value: Math.floor(remaining / 3600),
    suffix: 'hs'
  }, {
    value: Math.floor(remaining % 3600 / 60),
    suffix: 'min'
  }, {
    value: remaining % 60,
    suffix: 'seg'
  }], [remaining]);
  return <div className="flex flex-col items-center text-center" data-id="element-15" data-mp="10cbrlcvfstco">
      <p className="text-[12px] font-medium uppercase tracking-[0.1em] text-cool" data-id="element-16" data-mp="10cv42e2bipjb">
        {label}
      </p>
      <div className="mt-4 flex items-stretch gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-17" data-mp="15an11mhtl1ud">
        {units.map(unit => <div key={unit.suffix} className="glass min-w-[86px] px-4 py-3 sm:min-w-[104px]" data-id="element-18" data-mp="xytt856ieh0g">
            <span className="block text-3xl font-bold tabular-nums tracking-tight text-ice sm:text-4xl" data-id="element-19" data-mp="szzcr9w0l4ji">
              {format(unit.value)}
            </span>
            <span className="mt-1 block text-[11px] font-medium uppercase tracking-[0.1em] text-cool" data-id="element-20" data-mp="12sy2ww75t358">
              {unit.suffix}
            </span>
          </div>)}
      </div>
      {note ? <p className="mt-4 text-sm text-cool" data-id="element-21" data-mp="a40vxp8eesrs">
          <span className="text-gold" data-id="element-22" data-mp="a5bzpp1ug0iw">⚠</span> {note}
        </p> : null}
    </div>;
}